import { render } from "./AppSideBar.vue?vue&type=template&id=e03cf356&scoped=true"
import script from "./AppSideBar.vue?vue&type=script&lang=js"
export * from "./AppSideBar.vue?vue&type=script&lang=js"

import "./AppSideBar.vue?vue&type=style&index=0&id=e03cf356&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/1-fbk-tabor/1-fbk-tabor/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e03cf356"]])

export default __exports__